// Persistent device-ID per browser. Used for kassa/team locks.
const KEY = "qdb_device_id";
const LABEL_KEY = "qdb_device_label";

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id =
      (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
      `dev-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function getDeviceLabel() {
  let l = localStorage.getItem(LABEL_KEY);
  if (!l) {
    // Auto-label based on UA: device + browser
    const ua = navigator.userAgent;
    let device = "Browser";
    if (/iPhone/i.test(ua)) device = "iPhone";
    else if (/iPad/i.test(ua)) device = "iPad";
    else if (/Android/i.test(ua)) device = "Android";
    else if (/Macintosh|Mac OS X/i.test(ua)) device = "Mac";
    else if (/Windows/i.test(ua)) device = "Windows";
    let browser = "";
    if (/CriOS/i.test(ua)) browser = "Chrome";
    else if (/FxiOS|Firefox/i.test(ua)) browser = "Firefox";
    else if (/EdgiOS|Edg/i.test(ua)) browser = "Edge";
    else if (/Chrome/i.test(ua)) browser = "Chrome";
    else if (/Safari/i.test(ua)) browser = "Safari";
    l = browser ? `${device} · ${browser}` : device;
    localStorage.setItem(LABEL_KEY, l);
  }
  return l;
}

export function setDeviceLabel(label) {
  localStorage.setItem(LABEL_KEY, label);
}
